import styled from 'styled-components';
import { motion } from 'framer-motion';
import { brand, ink, surface, textSize } from '../../../styles/brand';

export const Scrim = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(17, 20, 26, 0.38);
`;

export const Panel = styled(motion.div)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  padding: 0.6rem max(1.25rem, env(safe-area-inset-right, 0px))
    calc(1.5rem + env(safe-area-inset-bottom, 0px))
    max(1.25rem, env(safe-area-inset-left, 0px));
  border-radius: 1.4rem 1.4rem 0 0;
  background: ${brand.white};
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.12);
  touch-action: none;
  outline: none;
`;

export const Grabber = styled.span`
  width: 2.5rem;
  height: 0.3rem;
  flex: none;
  border-radius: 999px;
  background: ${surface.line};
`;

export const Title = styled.h3`
  margin: 0;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(1.1)};
  letter-spacing: -0.01em;
  color: ${ink};
`;
